/* Copyright (c) Trimble Inc. All rights reserved. */
import { InputContainer } from "modus/components/form/input-container/InputContainer";
import React from "react";
import { useSelector } from "react-redux";
import { MY_SELECTED_TEAM_ } from "header/team-selector/TeamSelector";
import { NotificationActionsProps } from "./TeamNotificationActions";

export const NotificationActionsDialogComponents: React.FC<
  NotificationActionsProps
> = ({ notification, refreshApprovals }) => {
  const teamName = useSelector((state: any) =>state?.teamManager?.teams?.currentTeam?.name ??localStorage.getItem(MY_SELECTED_TEAM_));

  return (
    <>
      <InputContainer
        label={"Email"}
        value={notification?.requestedBy?.emailAddress}
        name={"email"}
        disabled={true}
      ></InputContainer>
      {notification?.requestedBy?.accountName && (<InputContainer
        label={"Account"}
        value={notification?.requestedBy?.accountName}
        name={"account"}
        disabled={true}
      />)}
      <InputContainer
        label={"Team"}
        value={notification?.requestedBy?.team ?? teamName}
        name={"team"}
        disabled={true}
      ></InputContainer>
    </>
  );
};

export default NotificationActionsDialogComponents;
